module.exports = __webpack_public_path__ + "img/vo-560.d6a49bab.jpg";